
// import logo from './logo.svg';
// import './App.css';
// import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import Login from './pages/Login';
// import Homepage from './pages/Home';
// import ThermostatDetails from './pages/Thermostats';
// import InverterDetails from './pages/ElectricalVehical';
// import { useState } from 'react';
// import DispatchResource from './pages/DispatchResources';
// import VehicleDetails from './pages/vehical';
// import FranklinDetails from './pages/franklinDetails';

// function App() {
//   const [data, setData] = useState(null);
//   return (

//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<Login/>}></Route>
//         <Route path="/Home" element={<Homepage />}></Route>
//         <Route path="/DispatchResource" element={<DispatchResource />}></Route>
//         <Route path="/ThermostatDetails" element={<ThermostatDetails data={data} />}></Route>
//         <Route path="/InverterDetails" element={<InverterDetails />}></Route>

//         <Route path="/VehicleDetails" element={<VehicleDetails />}></Route>
//         <Route path="/FranklinDetails" element={<FranklinDetails />}></Route>
//     </Routes>

//     </BrowserRouter>

//   );
// }

// export default App;
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Homepage from './pages/Home';
import ThermostatDetails from './pages/Thermostats';
import InverterDetails from './pages/ElectricalVehical';
import DispatchResource from './pages/DispatchResources';
import VehicleDetails from './pages/vehical';
import FranklinDetails from './pages/franklinDetails';
import FranklinUnified from './pages/FranklinUnified';
import SolArkDetails from './pages/SolArk';
import HoymilesDetails from './pages/Hoymiles';
import PPAProjects from './pages/PPAProjects';
import WeatherDashboard from './pages/WeatherDashboard';

import PrivateRoute from './component/privateRoutes'; // import the wrapper
import { useState } from 'react';
import BatteryDetails from './pages/Battery';

import { DataProvider } from './context/DataContext';

function App() {
  const [data, setData] = useState(null);

  return (
    <DataProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />

          {/* Protected Routes */}
          <Route path="/Home" element={
            <PrivateRoute>
              <Homepage />
            </PrivateRoute>
          } />

          <Route path="/DispatchResource" element={
            <PrivateRoute>
              <DispatchResource />
            </PrivateRoute>
          } />

          <Route path="/ThermostatDetails" element={
            <PrivateRoute>
              <ThermostatDetails data={data} />
            </PrivateRoute>
          } />

          <Route path="/InverterDetails" element={
            <PrivateRoute>
              <InverterDetails />
            </PrivateRoute>
          } />
          <Route path="/BatteryDetails" element={
            <PrivateRoute>
              <BatteryDetails />
            </PrivateRoute>
          } />
          <Route path="/VehicleDetails" element={
            <PrivateRoute>
              <VehicleDetails />
            </PrivateRoute>
          } />

          <Route path="/FranklinDetails" element={
            <PrivateRoute>
              <FranklinDetails />
            </PrivateRoute>
          } />
          <Route path="/SolArkDetails" element={
            <PrivateRoute>
              <SolArkDetails />
            </PrivateRoute>
          } />

          <Route path="/HoymilesDetails" element={
            <PrivateRoute>
              <HoymilesDetails />
            </PrivateRoute>
          } />

          <Route path="/FranklinUnifiedDetails" element={
            <PrivateRoute>
              <FranklinUnified />
            </PrivateRoute>
          } />

          <Route path="/PPAProjects" element={
            <PrivateRoute>
              <PPAProjects />
            </PrivateRoute>
          } />

          <Route path="/WeatherDashboard" element={
            <PrivateRoute>
              <WeatherDashboard />
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
    </DataProvider>
  );
}

export default App;
